import React from "react";
import { useRouter, withRouter } from "next/router";
import { WithRouterProps } from "next/dist/client/with-router";
import { CTAContainer, ContentContainer, EndingPhrase, ImageContainer, SubTitle, SuccessContainer, SuccessImage, Title, TitleContainer } from "./Success.styles";
import Logo from '../../../../../public/images/logo-new.svg';
import { Button, List } from "../../../../components";
import { LastMinListArray, ListArray } from "./Success.content";
import Image from "next/image";

/**
 * "lastMin" is for an application that landed in the last min queue rather than the request
 * queue — same three steps, but the offer arrives by SMS at short notice instead of weeks
 * ahead, so the standard copy would set the wrong expectation.
 */
export type SuccessVariant = "standard" | "lastMin";

interface SuccessProps extends WithRouterProps {
  firstName: string | undefined;
  bookingInterestId: number | undefined | null;
  variant?: SuccessVariant;
}

const Success: React.FC<SuccessProps> = ({
  firstName,
  bookingInterestId,
  variant = "standard",
}) => {
  const router = useRouter();
  const isLastMin = variant === "lastMin";

  const redirectToAddSession = () => {
    router.reload()
  };

  return (
    <SuccessContainer
      data-cy="booking-interest-registration-success"
      data-cy-variant={variant}
      data-bookinginterest-id={bookingInterestId}>
      <TitleContainer>
        <SuccessImage>
          <Logo />
        </SuccessImage>
        <Title>
          {isLastMin
            ? `You’re on the Last Minute List ${firstName}!`
            : `You’re on the List for Tickets ${firstName}!`}
        </Title>
      </TitleContainer>
      <ContentContainer>
        <SubTitle>
          So, What Happens Now?
        </SubTitle>
        <ImageContainer>
          <Image src="/images/email/progress-red-carpet-application.png" fill alt="Progress bar - applied for tickets step" />
        </ImageContainer>
        <List elements={isLastMin ? LastMinListArray : ListArray} />
      </ContentContainer>
      <CTAContainer>
        <EndingPhrase>
          Want to increase your chances of getting tickets?
        </EndingPhrase>
        <Button onClick={() => router.reload()} data-cy="book-another-ticket-button"> Apply for another Session </Button>
      </CTAContainer>
    </SuccessContainer>
  );
};

export default withRouter(Success);
